import React from 'react';
import { Button } from '@business/workflows/ComponentUI';
import { SelectionBarProps } from '@business/interfaces/photo';
import { useTranslation } from 'react-i18next';

export const SelectionBar: React.FC<SelectionBarProps> = ({
  selectedCount,
  itemType,
  actions,
  className = '',
  position = 'fixed'
}) => {
  const { t } = useTranslation();
  const getItemLabel = () => {
    if (itemType === 'photo') {
      return selectedCount === 1 ? 'item' : 'items';
    } else if (itemType === 'folder') {
      return selectedCount === 1 ? 'folder' : 'folders';
    } else if (itemType === 'people') {
      return selectedCount === 1 ? 'person' : 'people';
    }
    return selectedCount === 1 ? 'item' : 'items';
  };

  if (selectedCount === 0) return null;

  const positionClasses =
    position === 'fixed'
      ? 'fixed top-16 left-64 right-0 z-40 mx-auto'
      : 'relative mb-3 rounded-sm';

  return (
    <div
      className={`bg-white shadow-md px-6 py-3 flex items-center justify-between ${positionClasses} ${className}`}>
      <div className="flex items-center gap-3 pt-3">
        <span className="text-sm text-gray-700">
          {selectedCount} {getItemLabel()} {t('selected')}
        </span>
      </div>
      <div className="flex items-center gap-4 pt-3">
        {actions.map((action, index) => (
          <Button
            key={index}
            btnStyle="no-outline"
            onClick={action.onClick}
            className={`p-2 hover:bg-gray-100 rounded-md transition-colors ${action.className || ''}`}
            title={action.title}>
            {action.icon}
          </Button>
        ))}
      </div>
    </div>
  );
};
